import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MapWaldCoreModule } from 'map-wald';
import { MapWaldLeafletModule } from 'map-wald-leaflet';
import { TerrakioModule } from 'terrakio';

import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MainMapComponent } from './main-map/main-map.component';
import { MapButtonsComponent } from './map-buttons/map-buttons.component';
import { ChartComponent } from './chart/chart.component';
import { VectorLayerSelectionComponent } from './vector-layer-selection/vector-layer-selection.component';
import { AboutComponent } from './about/about.component';
// import { DownloadFormComponent } from './download-form/download-form.component';
import { FeatureDataService } from './feature-data.service';
import { PointDataService } from './point-data.service';
import { LayersService } from './layers.service';
import { DisplaySettingsComponent } from './display-settings/display-settings.component';
import { OpacitySliderComponent } from './opacity-slider/opacity-slider.component';
import { TimeSliderComponent } from './time-slider/time-slider.component';
import { MultiYearTimeseriesChartComponent } from './multi-year-timeseries-chart/multi-year-timeseries-chart.component';
import { LogoBlockComponent } from './logo-block/logo-block.component';
import { ZonalService } from './zonal.service';
import { TimePeriodSelectionComponent } from './time-period-selection/time-period-selection.component';
import { MapLayerSelectionComponent } from './map-layer-selection/map-layer-selection.component';
import { ChartPanelComponent } from './chart-panel/chart-panel.component';
import { WMSParameterService } from './wms-parameter.service';
import { MonthPickerComponent } from './month-picker/month-picker.component';
import { RangedIntegerComponent } from './ranged-integer/ranged-integer.component';
import { FaIconComponent } from './fa-icon.component';
import { RouterModule } from '@angular/router';
import { DownloadFormComponent } from './download-form/download-form.component';

@NgModule({
  declarations: [
    AppComponent,
    MainMapComponent,
    MapButtonsComponent,
    ChartComponent,
    VectorLayerSelectionComponent,
    AboutComponent,
    DisplaySettingsComponent,
    OpacitySliderComponent,
    TimeSliderComponent,
    MultiYearTimeseriesChartComponent,
    LogoBlockComponent,
    TimePeriodSelectionComponent,
    MapLayerSelectionComponent,
    ChartPanelComponent,
    MonthPickerComponent,
    RangedIntegerComponent,
    FaIconComponent,
    DownloadFormComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    MapWaldCoreModule.forRoot({}),
    MapWaldLeafletModule.forRoot({}),
    TerrakioModule.forRoot({}),
    RouterModule.forRoot([])
  ],
  providers: [
    FeatureDataService,
    PointDataService,
    LayersService,
    ZonalService,
    WMSParameterService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
